import { type AppId, appIdToAppInfoMap } from '@post-office/rovo-expansion-common';

/** Names no `AppId` generates; platform keeps the last two as legacy aliases. */
const CONNECTOR_NAME_ALIASES: (readonly [string, AppId])[] = [
	['smartlinks-connector-gdrive-rsl', 'drive'],
	['lite-connector-gdrive', 'drive'],
	['ai-3p-connector:google-workspace', 'drive'],
	['ai-3p-connector:sharepoint-domain', 'sharepoint'],
];

const appIdByConnectorName = new Map<string, AppId>();

// The map is declared `Record<AppId, AppInfo>`, so every key is an `AppId`.
for (const appId of Object.keys(appIdToAppInfoMap) as AppId[]) {
	const { smartlinkConnectorType, fullConnectorType } = appIdToAppInfoMap[appId];

	appIdByConnectorName.set(smartlinkConnectorType ?? `smartlinks-connector-${appId}`, appId);
	appIdByConnectorName.set(fullConnectorType ?? `${appId}-connector`, appId);
}

// After the generated names, so a legacy alias wins on any collision.
for (const [connectorName, appId] of CONNECTOR_NAME_ALIASES) {
	appIdByConnectorName.set(connectorName, appId);
}

/** Resolves a connector row `name` back to the product it belongs to. */
export const resolveAppIdForConnectorName = (connectorName: string): AppId | undefined =>
	appIdByConnectorName.get(connectorName);
